import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classnames from 'classnames'
import { History } from 'history'

import { fetchAdminIndex } from './adminActions'
import { nextPage, previousPage } from '../../helpers/paginationHelper'
import {
  selectAdminUserIndex,
  selectAdminUserMeta,
} from '../../reducers/adminUsers'
import { parseQuery, stringifyQuery } from '../../helpers/queryHelper'
import { displayNotification } from '../../actions/notificationsActions'
import { User } from '../../core/types'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'

interface Meta {
  total: number
}

export type Callback<T = void> = (...args: any) => T

export interface Props {
  fetchAdminIndex: Callback
  displayNotification: Callback
  currentAdmins: User[]
  history: History
  meta: Meta
  location: { key: any } & Location
}

export class AdminIndex extends Component<Props> {
  static displayName = 'AdminIndex'

  componentWillMount() {
    const { location, history, fetchAdminIndex } = this.props
    if (!location.search) {
      history.push({
        pathname: '/admins',
        search: stringifyQuery({ offset: 0, limit: 25 }),
      })
    } else {
      fetchAdminIndex(parseQuery(location.search))
    }
  }

  componentDidUpdate(prevProps) {
    const {
      fetchAdminIndex,
      location: { search },
    } = this.props
    if (search !== prevProps.location.search) {
      fetchAdminIndex(parseQuery(search))
    }
  }

  prevPageClick = () => {
    const {
      location: { search },
    } = this.props
    previousPage(search, this.props.history, '/admins')
  }

  nextPageClick = () => {
    const {
      currentAdmins,
      location: { search },
    } = this.props
    nextPage(search, this.props.history, currentAdmins.length, '/admins')
  }

  openPage = (id) => {
    const {
      history: { push },
    } = this.props
    push({ pathname: `/admins/${id}` })
  }

  orgLabel = (organization) => {
    if (!organization) return "-- Unassigned --"
    return `${(organization.nameLegal || organization.code || 'Org')} (#${organization.id})`
  }

  render() {
    const { currentAdmins, meta, location } = this.props
    const { total } = meta
    const { search } = location
    const parsedSearch = parseQuery(search)
    const rows = currentAdmins.map((user, index) => {
      const { id, firstName, lastName, email, organization } = user
      return (
        <tr
          className="index-table__row"
          key={index}
          onClick={() => this.openPage(id)}
          data-testid="adminIndexRow"
        >
          <td className="index-table__cell">{`${lastName}, ${firstName}`}</td>
          {email ? <td className="index-table__cell">{email}</td> : <td />}
          <td className="index-table__cell">{this.orgLabel(organization)}</td>
        </tr>
      )
    })
    const levels = [
      { label: 'Index ', path: '/' },
      { label: 'Admins', path: '/admins' },
    ]

    return (
      <>
        <Breadcrumb levels={levels} />
        <LoadingSection isLoading={false}>
          <div className="index" key={location.key}>
            <Link
              data-testid="CreateAdminLink"
              to={'/admins/create'}
              className="index-table__filter-button"
            >
              Create Admin
            </Link>
            <table className="index-table">
              <thead>
                <tr className="index-table__row--head">
                  <th className="index-table__cell">NAME (last, first)</th>
                  <th className="index-table__cell">EMAIL</th>
                  <th className="index-table__cell">Organization</th>
                </tr>
              </thead>
              <tbody className="index-table__body">{rows}</tbody>
            </table>
            <div className="index-table__button-row">
              <a
                data-testid="previousPageLink"
                onClick={this.prevPageClick}
                className={classnames(
                  'index-table__button',
                  'index-table__button--previous',
                  'icon-arrow',
                  {
                    'index-table__button--disabled':
                      parsedSearch.limit > parsedSearch.offset,
                  }
                )}
              />
              <a
                data-testid="nextPageLink"
                onClick={this.nextPageClick}
                className={classnames(
                  'index-table__button',
                  'index-table__button--next',
                  'icon-arrow',
                  {
                    'index-table__button--disabled':
                      currentAdmins.length < parsedSearch.limit,
                  }
                )}
              />
            </div>
          </div>
        </LoadingSection>
      </>
    )
  }
}

export const mapStateToProps = (state) => {
  return {
    currentAdmins: selectAdminUserIndex(state.adminUsers),
    meta: selectAdminUserMeta(state.adminUsers),
  }
}

export default withRouter(
  connect(mapStateToProps, {
    fetchAdminIndex,
    displayNotification,
  })(AdminIndex)
)
